import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-expenses-report-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './expenses-report-page.component.html',
  styleUrl: './expenses-report-page.component.css'
})
export class ExpensesReportPageComponent {

}
